module.exports = __webpack_public_path__ + "static/media/clancy.2e318577.png";